import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PPIService from "../../services/PPIService";
import moment from "moment";

const TransactionHistory = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await PPIService.cardTransactionHistory();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Failed to fetch", "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        setData(responseData.data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const getTransactionTypeLabel = (type) => {
    switch (type) {
      case 1:
        return "Credit";
      case 2:
        return "Debit";
      case 4:
        return "Cashback";
      case 9:
        return "Void";
      case 16:
        return "Reissuance Charge";
      case 17:
        return "Refund";
      case 18:
        return "Reversal";
      case 19:
        return "Surcharge Debit";
      case 20:
        return "Surcharge Void";
      case 21:
        return "Surcharge Reversal";
      default:
        return "Other";
    }
  };

  const formatAmount = (amount, type) => {
    const isCredit = [1, 4, 17, 18, 21].includes(type);
    const prefix = isCredit ? "+" : "-";
    const colorClass = isCredit ? "text-success" : "text-danger";
    return (
      <span className={`fw-bold ${colorClass}`}>
        {prefix}₹{(amount / 100).toFixed(2)}
      </span>
    );
  };

  return (
    <React.Fragment>
      <div className="p-2">
        <h5 className="mb-3">Recent Transactions</h5>

        {loading ? (
          <p>Loading...</p>
        ) : data?.length === 0 ? (
          <p>No transactions found.</p>
        ) : (
          <div className="list-group">
            {data.map((item, index) => (
              <div
                key={index}
                className="list-group-item d-flex justify-content-between align-items-start flex-column"
              >
                <div className="d-flex justify-content-between w-100">
                  <strong>{item.merchantName?.trim() || "N/A"}</strong>
                  {formatAmount(item.transactionAmount, item.transactionType)}
                </div>

                <div className="d-flex justify-content-between w-100 text-muted small mt-1">
                  <span>
                    {getTransactionTypeLabel(item.transactionType)} |{" "}
                    {moment(item.transactionDate).format(
                      "DD MMM YYYY, hh:mm A"
                    )}
                  </span>
                  <span>{item.invoiceNumber}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default TransactionHistory;
